import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import * as moment from 'moment';
import LaunchedOutlinedIcon from '@material-ui/icons/LaunchOutlined';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import { fileSelectHandler } from '../../util/fileHandling';
import { withStyles } from '@material-ui/core/styles';
import {
  TextField,
  FormHelperText,
  Button,
  Radio,
  Link,
  Grid,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import * as EmailValidator from 'email-validator';
import PhoneInput from '../../components/PhoneInput';
import DateSelect from '../../components/DateSelect';
import NoticeDialog from '../../components/DialogModals/NoticeDialog';
import { signupPatient, isEmailAvailable } from '../../services/api';
import { ADULTHOOD_AGE } from '../../constants';
import './style.css';

const validatePhone = num => {
  return num.replace(/[a-z\W]/gi, '').length === 10 && !/[a-z]/i.test(num);
};

function SignUp(props) {
  const {
    affiliateId,
    history,
    classes: {
      formControl,
      root,
      container,
      labelWithLink,
      datePicker,
      zipcodeInput,
      warning,
      input,
      submitButton,
      helperText,
      header,
      giantHeader,
      signUpcard,
    },
  } = props;

  const [personalDetails, setPersonalDetails] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    zipcode: '',
    birthdate: null,
    gender: '',
    email: '',
    password: '',
    passwordConfirmation: '',
    legal: false,
    hipaa: false,
    insuranceName: '',
    insuranceId: '',
  });
  const [validationErrors, setValidationErros] = useState({});
  const [validationImageErrors, setValidationImageErrors] = useState({});
  const [popMessege, setPopMessege] = useState('');
  const [sessionStorageValue, setSessionStorageValue] = useState(null);
  const [specialityStorage, setSpecialtyStorage] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [imageFront, setImageFront] = useState([]);
  const [imageBack, setImageBack] = useState([]);
  const [popNotice, setPopNotice] = useState('');
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const myRef = useRef(null);

  useEffect(() => {
    const getUrl = sessionStorage.getItem('redirect1');
    const getUrl2 = sessionStorage.getItem('redirect2');
    // setSessionStorageValue(getUrl)
    if (getUrl) {
      setSessionStorageValue(getUrl);
      setSpecialtyStorage(null);
    } else {
      setSpecialtyStorage(getUrl2);
      setSessionStorageValue(null);
    }
  }, []);
  const affiliateInOffice = () => {
    return window.localStorage.getItem('in-office') === 'true';
  };


  const handleClickShowPassword = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  
  
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Email onChange function
  const emailOnChange = event => {
    setPersonalDetails({ ...personalDetails, email: event.target.value });
    setValidationErros({ ...validationErrors, [event.target.name]: false });
  };

  // Dateselect onChange function
  const handleDateChange = date => {
    const patientBirthDate = moment.utc(date);
    const now = moment.utc();
    if (
      patientBirthDate._isValid &&
      now.diff(patientBirthDate, 'years') < ADULTHOOD_AGE
    ) {
      setPopMessege(
        'Users under the age of 18 should register through thier guardians account.'
      );
      return;
    }
    setValidationErros({
      ...validationErrors,
      birthdate: false,
    });
    setPersonalDetails({
      ...personalDetails,
      birthdate: moment.utc(date).format('MM/DD/YYYY'),
    });
  };

  const handleChange = event => {
    if (event.target.name === 'legal' || event.target.name === 'hipaa') {
      setPersonalDetails({
        ...personalDetails,
        [event.target.name]: event.target.checked,
      });
    } else {
      setPersonalDetails({
        ...personalDetails,
        [event.target.name]: event.target.value,
      });
    }
    setValidationErros({ ...validationErrors, [event.target.name]: false });
  };

  const validateErrorInfo = () => {
    let valid = true;
    const nextValidationErrors = {};
    if (
      !personalDetails.firstName ||
      !personalDetails.firstName.replace(/^\s+|\s+$/gm, '')
    ) {
      valid = false;
      nextValidationErrors.firstName = 'Required';
    }
    if (
      !personalDetails.lastName ||
      !personalDetails.lastName.replace(/^\s+|\s+$/gm, '')
    ) {
      valid = false;
      nextValidationErrors.lastName = 'Required';
    }
    if (!personalDetails.email) {
      valid = false;
      nextValidationErrors.email = 'Required';
    } else if (!EmailValidator.validate(personalDetails.email)) {
      valid = false;
      nextValidationErrors.email = 'Must be a valid email';
    }
    if (!personalDetails.phone) {
      valid = false;
      nextValidationErrors.phone = 'Required';
    } else if (personalDetails.phone && !validatePhone(personalDetails.phone)) {
      valid = false;
      nextValidationErrors.phone = 'Must be a valid phone number';
    }
    if (!personalDetails.zipcode) {
      valid = false;
      nextValidationErrors.zipcode = 'Required';
    } else if (!personalDetails.zipcode.match(/^\d{5}$|^\d{5}-\d{4}$/)) {
      valid = false;
      nextValidationErrors.zipcode = 'Must be a valid zipcode';
    }
    if (!personalDetails.gender) {
      valid = false;
      nextValidationErrors.gender = 'Required';
    }
    if (!personalDetails.birthdate) {
      valid = false;
      nextValidationErrors.birthdate = 'Required';
    } else if (
      moment.utc(personalDetails.birthdate).format('YYYY-MM-DD') ===
      'Invalid date'
    ) {
      valid = false;
      nextValidationErrors.birthdate = 'Invalid Date';
    }
    if (!personalDetails.password) {
      valid = false;
      nextValidationErrors.password = 'Required';
    } else if (personalDetails.password.length < 2) {
      valid = false;
      nextValidationErrors.password = 'Password length must be minimum 2';
    }
    if (!personalDetails.passwordConfirmation) {
      valid = false;
      nextValidationErrors.passwordConfirmation = 'Required';
    } else if (
      personalDetails.passwordConfirmation !== personalDetails.password
    ) {
      valid = false;
      nextValidationErrors.passwordConfirmation =
        'Password and confirmation password does not match';
    }
    if (!personalDetails.legal) {
      nextValidationErrors.legal =
        'You need to agree to our terms and conditions';
      valid = false;
    }
    if (!personalDetails.hipaa) {
      nextValidationErrors.hipaa = 'You need to agree to our privacy policy';
      valid = false;
    }
    setValidationErros(nextValidationErrors);
    return valid;
  };

  // Submit function
  const handleSubmit = async event => {
    event.preventDefault();
    let {
      firstName,
      lastName,
      email,
      phone,
      zipcode,
      birthdate,
      gender,
      password,
      insuranceName,
      insuranceId,
    } = personalDetails;

    if (imageBack.length == 0 && imageFront.length == 0) {
      if (validateErrorInfo()) {
        setButtonDisable(true);
        await signupPatient({
          firstName: firstName.replace(/^\s+|\s+$/gm, ''),
          lastName: lastName.replace(/^\s+|\s+$/gm, ''),
          email,
          phone,
          zipcode,
          birthdate,
          gender,
          password,
          affiliateId,
          affiliateInOffice: affiliateInOffice,
          attachments: {
            imageFront: imageFront.map(i => i.dataUrl),
            imageBack: imageBack.map(i => i.dataUrl),
          },
          insuranceName,
          insuranceId,
        });
        setButtonDisable(false);
        navigateToConfirmation();
      } else {
        setButtonDisable(false);
      }
    } else if (imageBack.length > 0 && imageFront.length > 0) {
      if (validateErrorInfo()) {
        setButtonDisable(true);
        await signupPatient({
          firstName: firstName.replace(/^\s+|\s+$/gm, ''),
          lastName: lastName.replace(/^\s+|\s+$/gm, ''),
          email,
          phone,
          zipcode,
          birthdate,
          gender,
          password,
          affiliateId,
          affiliateInOffice: affiliateInOffice,
          attachments: {
            imageFront: imageFront.map(i => i.dataUrl),
            imageBack: imageBack.map(i => i.dataUrl),
          },
          insuranceName,
          insuranceId,
        });
        setButtonDisable(false);
        navigateToConfirmation();
      }
    } else {
      setButtonDisable(false);
    }

    // await signupPatient({
    //   firstName,
    //   lastName,
    //   email,
    //   phone,
    //   zipcode,
    //   birthdate,
    //   gender,
    //   password,
    //   affiliateId,
    //   affiliateInOffice: affiliateInOffice,
    // });
    // navigateToConfirmation();
  };
  const navigateToConfirmation = () => {
    const setDefaultState = () => {
      setPersonalDetails({
        firstName: '',
        lastName: '',
        phone: '',
        zipcode: '',
        birthdate: null,
        gender: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        legal: false,
        hipaa: false,
        insuranceName: '',
        insuranceId: '',
      });
      setImageBack([]);
      setImageFront([]);
    };

    if (affiliateId) {
      history.push(`/affiliate/sign-up/confirmation/${affiliateId}`);
    } else {
      if (sessionStorageValue === null && specialityStorage === null) {
        history.push({ pathname: '/sign-up/confirmation' });
      } else if (specialityStorage !== null) {
        sessionStorage.removeItem('redirect1');
        if (
          process.env.CLIENT_URL == 'undefined' ||
          process.env.CLIENT_URL == undefined
        ) {
          // window.location.assign(process.env.CLIENT_URL + '/specialties/search');
          sessionStorage.removeItem('redirect2');
          setSpecialtyStorage(null);
          window.location.assign('https://qwell.com/specialties/search');
        } else {
          sessionStorage.removeItem('redirect2');
          setSpecialtyStorage(null);
          // window.location.assign('https://qwell.com/specialties/search');
          window.location.assign(
            process.env.REACT_APP_CLIENT_URL + '/specialties/search'
          );
        }
      } else {
        sessionStorage.removeItem('redirect1');
        sessionStorage.removeItem('redirect2');
        // window.location.assign(process.env.REACT_APP_CLIENT_URL + '/concierge-pricing');
        window.location.assign('https://qwell.com/concierge-pricing');
        setSessionStorageValue(null);
      }
    }
    setDefaultState();
  };

  const inputPicCallBack = fileObject => {
    setImageFront(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImageFront([]);
      }
    });
  };

  const inputPicBackCallBack = fileObject => {
    setImageBack(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImageBack([]);
      }
    });
  };

  const validateImageErrorInfo = () => {
    let valid = true;
    const nextValidationErrors = {};
    if (imageFront.length < 0) {
      valid = false;
      nextValidationErrors.imageFront = 'Required';
    }
    if (imageBack.length < 0) {
      valid = false;
      nextValidationErrors.imageBack = 'Required';
    }
    setValidationImageErrors(nextValidationErrors);
    return valid;
  };

  const callSetImageFront = event => {
    setImageFront([]);
    fileSelectHandler(
      event.target.files,
      inputPicCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const callSetImageBack = event => {
    setImageBack([]);
    fileSelectHandler(
      event.target.files,
      inputPicBackCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };
  return (
    <>
      <div className="signUpMargin">
        <div className={`${root} ${signUpcard}`}>
          <header className={header}>
            <h1 className={giantHeader}>Sign Up</h1>
          </header>
          <Grid item xs={12} spacing={0} classes={container}>
            <TextField
              fullWidth
              variant="outlined"
              label="First Name"
              name="firstName"
              value={personalDetails.firstName}
              error={validationErrors.firstName}
              helperText={validationErrors.firstName}
              onChange={handleChange}
              className={input}
            />
          </Grid>

          <Grid item xs={12} spacing={0} classes={container}>
            <TextField
              fullWidth
              variant="outlined"
              label="Last Name"
              name="lastName"
              value={personalDetails.lastName || ''}
              error={validationErrors.lastName}
              helperText={validationErrors.lastName}
              onChange={handleChange}
              className={input}
            />
          </Grid>

          <Grid item xs={12} spacing={0} classes={container}>
            <TextField
              fullWidth
              label="Email"
              value={personalDetails.email || ''}
              variant="outlined"
              name="email"
              onChange={emailOnChange}
              error={validationErrors.email}
              helperText={validationErrors.email}
              inputProps={{
                onBlur: async () => {
                  const available = await isEmailAvailable(
                    personalDetails.email
                  );
                  if (personalDetails.email && !available) {
                    setValidationErros({
                      ...validationErrors,
                      email: 'This email is already in use',
                    });
                  }
                },
              }}
            />
          </Grid>
          <div className="form-inline-section">
            <Grid item lg={6} xs={12} spacing={0} classes={container}>
              <TextField
                fullWidth
                label="Phone Number (Cell)"
                name="phone"
                value={personalDetails.phone || ''}
                error={validationErrors.phone}
                helperText={validationErrors.phone}
                variant="outlined"
                className={input}
                onChange={handleChange}
                InputProps={{
                  inputComponent: PhoneInput,
                }}
              />
            </Grid>

            <Grid item lg={6} xs={12} spacing={0} classes={container}>
              <TextField
                fullWidth
                label="Zipcode"
                name="zipcode"
                value={personalDetails.zipcode || ''}
                variant="outlined"
                onChange={handleChange}
                error={validationErrors.zipcode}
                helperText={validationErrors.zipcode}
                className={input}
              />
            </Grid>
          </div>
          <div className="form-inline-section">
            <Grid item xs={12} lg={6}>
              <TextField
                fullWidth
                name="insuranceName"
                variant="outlined"
                label="Insurance Name"
                value={personalDetails.insuranceName || ''}
                onChange={handleChange}
                className={input}
              />
              <FormHelperText className={helperText}> Optional </FormHelperText>
            </Grid>

            <Grid item xs={12} lg={6}>
              <TextField
                fullWidth
                name="insuranceId"
                variant="outlined"
                label="Insurance ID"
                value={personalDetails.insuranceId || ''}
                onChange={handleChange}
                className={input}
              />
              <FormHelperText className={helperText}> Optional </FormHelperText>
            </Grid>
          </div>
          <Grid item xs={12}>
            <FormHelperText
              className={helperText}
              style={{ color: '#055C9D', fontSize: '11px' }}
            >
              <WbIncandescentIcon fontSize="small" className="inv-bulb-icon" />
              We encourage you to enter your insurance information here, to help
              minimize your wait time at the time of your appointment{' '}
            </FormHelperText>
          </Grid>
          <div className="custom-inline-form">
            <Grid item xs={12} classes={container}>
              <FormLabel component="legend">Upload insurance front</FormLabel>
              <input
                type="file"
                ref={myRef}
                onChange={event => callSetImageFront(event)}
                className="custom-mt-10"
              />
              <FormLabel component="legend" className={warning}>
                {imageFront.length > 0 && imageBack.length > 0
                  ? ''
                  : imageBack
                  ? imageBack.length > 0
                    ? 'Required'
                    : ''
                  : ''}
              </FormLabel>
            </Grid>
            <Grid item xs={12} classes={container}>
              <FormLabel component="legend">Upload insurance back</FormLabel>
              <input
                type="file"
                ref={myRef}
                onChange={event => callSetImageBack(event)}
                className="custom-mt-10"
              />
              <FormLabel component="legend" className={warning}>
                {imageFront.length > 0 && imageBack.length > 0
                  ? ''
                  : imageFront
                  ? imageFront.length > 0
                    ? 'Required'
                    : ''
                  : ''}
              </FormLabel>
            </Grid>
          </div>

          <Grid item xs={12} classes={container}>
            <FormControl component="fieldset" variant="filled">
              <FormLabel component="legend">Gender</FormLabel>
              <RadioGroup
                row
                aria-label="Gender"
                name="gender"
                value={personalDetails.gender || ''}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="female"
                  control={<Radio />}
                  label="Female"
                />
                <FormControlLabel
                  value="male"
                  control={<Radio />}
                  label="Male"
                />
              </RadioGroup>
              {validationErrors.gender && (
                <FormLabel component="legend" className={warning}>
                  {validationErrors.gender}
                </FormLabel>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} classes={container}>
            <DateSelect
              disableFuture
              aria-label="birthdate"
              name="birthdate"
              format="MM/DD/YYYY"
              placeholder="MM/DD/YYYY ex. 10/2/1981"
              value={new Date(personalDetails.birthdate)}
              onChange={handleDateChange}
              className={datePicker}
              error={validationErrors.birthdate}
              helperText={validationErrors.birthdate}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type={showPassword.password ? 'text' : 'password'}
              label="Password"
              name="password"
              value={personalDetails.password || ''}
              variant="outlined"
              onChange={handleChange}
              error={validationErrors.password}
              helperText={validationErrors.password}
              autoComplete="current-password"
              className={input}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={() => handleClickShowPassword('password')}>
                    {showPassword.password ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type={showPassword.confirmPassword ? 'text' : 'password'}
              label="Password Confirmation"
              name="passwordConfirmation"
              value={personalDetails.passwordConfirmation || ''}
              variant="outlined"
              error={validationErrors.passwordConfirmation}
              helperText={validationErrors.passwordConfirmation}
              onChange={handleChange}
              className={input}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={() => handleClickShowPassword('confirmPassword')}>
                    {showPassword.confirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl required label="legal" error={!personalDetails.legal}>
              <div className={labelWithLink}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={personalDetails.legal}
                      value="legal"
                      name="legal"
                      onChange={handleChange}
                    />
                  }
                  label="I have read and accept Qwell's Terms of Use."
                />
                <Link
                  href={
                    process.env.REACT_APP_HOMEPAGE_URL +
                    '/patients-terms-of-use/'
                  }
                  target="_blank"
                  rel="noopener"
                >
                  <LaunchedOutlinedIcon className="icon" />
                </Link>
              </div>
              <FormHelperText>
                {!personalDetails.legal ? validationErrors.legal : ''}
              </FormHelperText>
            </FormControl>
            <FormControl required label="hipaa" error={!personalDetails.hipaa}>
              <div className={labelWithLink}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={personalDetails.hipaa || ''}
                      value="hipaa"
                      name="hipaa"
                      onChange={handleChange}
                    />
                  }
                  label="I have read and accept Qwell's Privacy Policy."
                />
                <Link
                  href={process.env.REACT_APP_HOMEPAGE_URL + '/privacy-policy'}
                  target="_blank"
                  rel="noopener"
                >
                  <LaunchedOutlinedIcon className="icon" />
                </Link>
              </div>
              <FormHelperText>
                {!personalDetails.hipaa ? validationErrors.hipaa : ''}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            className={submitButton}
            disabledduringonclick={true}
            disabled={buttonDisable}
          >
            Sign Up
          </Button>
          <NoticeDialog
            open={popMessege}
            onOkClick={() => setPopMessege('')}
            message={popMessege}
            noticeTitle={'Sorry'}
          />
        </div>
      </div>
      {popNotice && (
        <NoticeDialog
          open={popNotice}
          onOkClick={() => setPopNotice('')}
          noticeTitle="Notice"
          message={popNotice}
        />
      )}
    </>
  );
}

const styles = theme => ({
  formControl: {
    marginBottom: '-3em',
    padding: '0em',
  },
  root: {
    width: '45%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '65px auto 0',
    [theme.breakpoints.down('sm')]: {
      marginTop: '35px',
    },
  },
  container: {
    width: '30%',
    backgroundColor: 'white',
    padding: '2rem',
    border: '1px solid rgba(183,210,229,0.8)',
    borderRadius: '8px',
    boxShadow: 'inset 0 -1px 0 0 #7E95A7, 0 1px 4px 0 rgba(44,64,90,0.21)',
    [theme.breakpoints.down('lg')]: {
      width: '45%',
    },
    [theme.breakpoints.down('md')]: {
      width: '65%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
  },
  labelWithLink: {
    display: 'flex',
    alignItems: 'center',
  },
  datePicker: {
    width: '75%',
  },
  zipcodeInput: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: '0px !important',
  },
  warning: {
    color: '#f44336',
    fontSize: '0.75rem',
    marginLeft: '38px',
    marginTop: '18px',
  },
  input: {
    margin: '0.5rem 0 0',
    display: 'block',
  },
  helperText: {
    marginLeft: '10px',
  },
  submitButton: {
    color: 'white',
    minWidth: '50%',
    marginLeft: '0',
    '@media only screen and (max-width: 1024px)': {
      padding: '1em',
      marginLeft: '0',
      marginBottom: '1em',
    },
  },
  giantHeader: {
    fontSize: '2em',
    fontWeight: 'bold',
  },
  header: {
    color: '#505D68',
    lineHeight: '44px',
    marginBottom: '0',
    padding: '2rem 2rem 0',
  },
  signUpcard: {
    border: '1px solid rgba(183,210,229,0.8)',
    boxShadow: 'inset 0 -1px 0 0 #7e95a7, 0 1px 4px 0 rgb(44 64 90 / 21%)',
    borderRadius: '8px',
    backgroundColor: 'white',
    marginBottom: '40px !important',
  },
});

export default withRouter(withStyles(styles)(SignUp));
